'use client';

import {useMemo} from 'react';
import type {MyList} from 'server/apiHandlers/getMyListsHandler';
import ListMapSideContent from './ListMapSideContent';
import {useFilteredPlaces} from './useFilteredPlaces';
import {useMapResize} from './useMapUtils';
import MapLayout from './MapLayout';
import useMap from './useMap';

type Props = {
  list: HumboList;
  reviews: Review[];
  myLists: MyList[];
  headerComponent?: React.ReactNode;
  session: IronSession | null;
};

const ListMapContent = ({list, reviews, myLists, headerComponent, session}: Props) => {
  const places: Place[] = useMemo(() => list.places.map((placeEntry) => placeEntry.place), [list]);
  const filteredPlaces = useFilteredPlaces(places);

  const {mapContainer, map} = useMap({variant: 'places', places: filteredPlaces});

  useMapResize(mapContainer, map);

  return (
    <MapLayout
      map={map}
      places={places}
      reviews={reviews}
      myLists={myLists}
      mapContainer={mapContainer}
      listName={list.name}
      listUser={list.user}
      headerComponent={headerComponent}
      session={session}
    >
      <ListMapSideContent places={places} reviews={reviews} map={map} />
    </MapLayout>
  );
};

export default ListMapContent;
